import axios from 'axios'

// Controllers answer failures with { errors: string[] } (a few with { errors: string });
// anything else (HTML 404/500, a redirect, an empty list) collapses to the caller's fallback.
const extractServerErrors = (error: unknown, fallback: string): string[] => {
  const serverErrors: unknown = axios.isAxiosError(error)
    ? error.response?.data?.errors
    : null
  if (typeof serverErrors === 'string' && serverErrors !== '') {
    return [serverErrors]
  }
  return Array.isArray(serverErrors) &&
    serverErrors.length > 0 &&
    serverErrors.every((entry) => typeof entry === 'string')
    ? serverErrors
    : [fallback]
}

export default extractServerErrors
